import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import Select from 'react-select';
import { reaction, observable } from "mobx";
import moment from "moment/moment";
import DataWrapper from '../../principal/containers/DataWrapper';
import { Row, Col, FormGroup, Label, Input, Button } from 'reactstrap';
import { TabelaCadastro } from "../../cadastros/components/TabelaCadastro";
import AtualizacaoGestorSolicitanteStore from "../stores/AtualizacaoGestorSolicitanteStore.js";
import { nullable } from "../../../utils/formatar";
import { Validacao } from "../../comum/components/Validacao";

const colunas = [
    {
        field: "idSolicitacao",
        label: "Solicitação"
    },
    {
        field: "idsContratacao",
        label: "Lista de Contratações"
    },
    {
        field: "qtdAcoes",
        label: "Ações pendentes"
    }
];

@inject("store")
@DataWrapper
@observer
export class AtualizacaoGestorSolicitante extends Component {

    constructor(props) {
        super(props);
        this.modal = this.props.store.modalStore;
        this.controller = new AtualizacaoGestorSolicitanteStore(this.modal);
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.modalStore = this.props.store.modalStore;
        this.appStore = this.props.store.appStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Atualização de Gestor Solicitante");
        this.controller.carregarLista();

        this.tituloPaginaStore.setBotoesMobile([
            {
                label: "Ordenar",
                icone: "sort",
                acao: () => this.modalStore.toggleModal('ordenar')
            }, {
                label: "Filtrar",
                icone: "search",
                acao: () => this.modalStore.toggleModal('filtrar')
            }
        ]);
    }

    modalForm = () => {
        return (
            <Row>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Novo Gestor Solicitante <sup>*</sup></Label>
                        <Select simpleValue cacheAsyncResults={false} value={this.controller.novoGestorSolicitanteFiltro}
                            valueKey={"matricula"}
                            labelKey={"nome"}
                            onChange={(value, option) => this.controller.setNovoGestorSolicitanteFiltro(value, option)}
                            searchPromptText="Informe matrícula para pesquisar"
                            noResultsText={"Gestor não encontrado no Conecta HCM."}
                            placeholder="Informe matrícula para pesquisar e selecione..."
                            asyncOptions={(input, callback) => this.controller.filtrarGestorSolicitante(input, callback, true)} />
                         <Validacao id="novoGestorSolicitanteFiltro" valor={this.controller.novoGestorSolicitanteFiltro} tipo={["isRequired", "empregadoGestor"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Solicitação Nº</Label>
                        <Input
                            type="text"
                            value={this.controller.itemSelecionado.idSolicitacao}
                            readOnly />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Lista de contratos</Label>
                        <Input
                            type="text"
                            value={this.controller.itemSelecionado.idsContratacao}
                            readOnly />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Centro de Custo</Label>
                        <Input
                            type="text"
                            value={this.controller.novoGestorSolicitanteFiltro ? this.controller.novoGestorSolicitanteFiltro.centroCusto : ""}
                            readOnly />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>N3</Label>
                        <Input
                            type="text"
                            value={this.controller.novoGestorSolicitanteFiltro ? this.controller.novoGestorSolicitanteFiltro.nomeDivisao : ""}
                            readOnly />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>N4</Label>
                        <Input
                            type="text"
                            value={this.controller.novoGestorSolicitanteFiltro ? this.controller.novoGestorSolicitanteFiltro.nomeDepartamento : ""}
                            readOnly />
                    </FormGroup>
                </Col>
            </Row>
        )
    }

    obterTituloMobile = (objeto) => {
        return objeto.usuarioResponsavel;
    };

    obterConteudoMobile = (objeto) => {
        return (
            <div>
                {"Solicitação: " + nullable(objeto.idSolicitacao)}<br />
                {"Lista: " + nullable(objeto.idsContratacao)}<br />
                {"Ações pendentes: " + nullable(objeto.qtdAcoes)}<br />
            </div>
        )
    };

    renderFilter() {
        return (
            <div className="filter-container">
                <div className="filter-box">
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Gestor Solicitante (incluindo desligados)<sup>*</sup></Label>
                                <Select
                                    simpleValue cacheAsyncResults={false} value={this.controller.gestorSolicitanteFiltro}
                                    valueKey={"matricula"}
                                    labelKey={"nome"}
                                    autoload={false}
                                    onChange={(value, option) => this.controller.setgestorSolicitanteFiltro(value, option)}
                                    searchPromptText="Informe matrícula para pesquisar"
                                    noResultsText={"Gestor não encontrado no Conecta HCM."}
                                    placeholder="Informe matrícula para pesquisar e selecione..."
                                    asyncOptions={(input, callback) => this.controller.filtrarGestorSolicitante(input, callback, false)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <Button color="primary" onClick={() => { this.controller.carregarLista(); }} >Filtrar</Button>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }

    renderDados() {
        return (
            <div>
                <TabelaCadastro
                    nomeCadastro={'Atualização de Gestor Solicitante'}
                    onChange={(value) => this.controller.setLista(value)}
                    listaItens={this.controller.solicitacoes}
                    colunas={colunas}
                    temBusca={true}
                    habilitarSelecaoMultipla={true}
                    modalEditar={this.modalForm()}
                    modalCadastrar={this.modalForm()}
                    preencherModal={(row) => this.controller.preencherModal(row)}
                    editar={() => this.controller.editar()}
                    tituloMobile={(row) => this.obterTituloMobile(row)}
                    conteudoMobile={(row) => this.obterConteudoMobile(row)}
                    loading={this.controller.loading}
                    mobileFilter={this.renderFilter()}
                />
            </div>
        );
    }

    render() {
        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel panel-sm" : "panel-sm"}>
                        {this.appStore.width > 768 && this.renderFilter()}
                        {this.renderDados()}
                    </div>
                </div>
            </div>
        );
    }
}